module.exports = __webpack_public_path__ + "assets/9bb5f4427ed5943222edb545f27766f0.png";